import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LAST_ERROR_STORAGE_KEY } from '../../shared/constant/app.constants';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly storage: Storage = localStorage;

  constructor(
    private readonly injector: Injector,
    private readonly zone: NgZone,
  ) {}

  handleError(error: Error | HttpErrorResponse | CloseEvent) {
    if (error && !(error instanceof CloseEvent)) {
      this.zone.run(() => this.injector.get(Router).navigate(['/error/server']));
      if (error instanceof Error) {
        this.storage.setItem(LAST_ERROR_STORAGE_KEY, `${error.message} | ${error.stack} `);
      } else if (error instanceof HttpErrorResponse) {
        this.storage.setItem(LAST_ERROR_STORAGE_KEY, `${error.message} | ${error.error} `);
      }
    }
    // Log the error anyway
    console.error(error);
  }
}
